import { render, staticRenderFns } from "./WheelFortune.vue?vue&type=template&id=fcb80754&scoped=true"
import script from "./WheelFortune.vue?vue&type=script&lang=js"
export * from "./WheelFortune.vue?vue&type=script&lang=js"
import style0 from "./WheelFortune.vue?vue&type=style&index=0&id=fcb80754&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb80754",
  null
  
)

export default component.exports